import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    Search as SearchIcon,
    Group as GroupIcon,
    ShieldOutlined as ShieldOutlinedIcon,
    Forum as ForumIcon,
    Home as HomeIcon,
    PersonAddAlt1 as PersonAddAlt1Icon,
    WarningAmber as WarningAmberIcon,
    CheckCircle as CheckCircleIcon,
    EmojiPeople as EmojiPeopleIcon
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアとSNS、今なぜ注目？
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('sns_property_search')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    SNSで物件を探すコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('sns_recruiting')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    SNSで住人募集を成功させるには
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble_avoidance')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    SNS活用でトラブルを防ぐポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experience')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    SNS活用ルームシェア体験談
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめとワンポイントアドバイス
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入部分 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアとSNS、今なぜ注目？
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアは、家賃の節約や生活の充実、そして新しい出会いを求める多くの人に選ばれる住まい方です。最近では、SNSを活用した物件探しや住人募集が主流となりつつあります。<b>Instagram・Twitter（X）・Facebookグループ・LINEオープンチャット</b>など、多彩なSNSを使いこなすことで、理想の住まいやルームメイトに出会う可能性が広がっています。
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                    SNSを上手に使えば、情報量・スピード・マッチング精度が大きくアップ。ですが、トラブルや失敗を防ぐためのコツも知っておくことが重要です。この記事では、SNSでの物件探し・住人募集のコツからトラブル回避、リアルな体験談まで、ルームシェアの専門的なSNS活用法を徹底解説します。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/roommate-sns-cafe_roomshare-sns-tips.jpg"
                        alt="カフェでスマホを片手にSNSでルームシェア物件情報を検索し、友達と相談する若い男女の様子。暖色系の照明とリラックスした雰囲気がSNSでの物件探しのリアルさを伝える"
                        style={{ width: '100%', borderRadius: 12, boxShadow: '0 4px 16px rgba(0,0,0,0.06)', marginBottom: 8 }}
                    />
                </Box>
            </Box>

            {/* SNSで物件を探すコツ */}
            <Box id="sns_property_search" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <SearchIcon sx={{ verticalAlign: 'middle', mr: 1, color: "#1976d2" }} />
                    SNSで物件を探すコツ
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    SNSでは、不動産サイトでは見つからない個人の物件情報や、家主・住人から直接募集されているレア物件が豊富です。<b>スピード感と柔軟さ</b>を活かして、理想の住まいを手に入れるためのポイントをご紹介します。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <HomeIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="最新情報は「公式ハッシュタグ」や「物件専用アカウント」をフォロー"
                            secondary="「#ルームシェア募集」「#東京ルームシェア」など、エリアや条件別のタグを活用。特定の物件専用Instagramアカウントでは、写真や部屋の雰囲気もチェックできます。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <ForumIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Facebookグループ・LINEオープンチャットは信頼性と量で勝負"
                            secondary="SNSのグループやオープンチャットには、実際に住んでいる人や管理者が情報を発信。入居者同士のリアルなやりとりや、入居前の質問も可能です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <SearchIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="DMやコメントから直接やりとりするときはプロフィール・過去投稿を必ず確認"
                            secondary="相手の信頼性や、どんな人なのかを把握するためには、SNSのプロフィールや投稿履歴をチェック。怪しいアカウントや情報には注意しましょう。"
                        />
                    </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#fafafa' }}>
                            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                                SNSごとの活用ポイント
                            </Typography>
                            <List sx={{ pl: 2 }}>
                                <ListItem sx={{ py: 0.5 }}>
                                    <Chip label="Instagram" color="primary" size="small" sx={{ mr: 1 }} />
                                    <Typography variant="body2" component="span">
                                        写真で部屋や住人の雰囲気が分かる。ストーリーやライブ配信で最新情報も。
                                    </Typography>
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <Chip label="Twitter(X)" color="primary" size="small" sx={{ mr: 1 }} />
                                    <Typography variant="body2" component="span">
                                        リアルタイムで募集情報が流れる。即時レスポンスや拡散力が強み。
                                    </Typography>
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <Chip label="Facebook" color="primary" size="small" sx={{ mr: 1 }} />
                                    <Typography variant="body2" component="span">
                                        グループ機能で信頼性・情報量ともに◎。管理者のいるコミュニティは安心。
                                    </Typography>
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <Chip label="LINE" color="primary" size="small" sx={{ mr: 1 }} />
                                    <Typography variant="body2" component="span">
                                        オープンチャットで気軽に質問や情報収集。実際の住人の声も聞きやすい。
                                    </Typography>
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1 }}>

                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" color="text.secondary">
                    ポイント：怪しい物件や詐欺アカウントも存在するため、<b>現地見学を必ず行い</b>、相手の連絡先や本人確認の有無もチェックしましょう。
                </Typography>
            </Box>

            {/* SNSで住人募集を成功させるには */}
            <Box id="sns_recruiting" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <PersonAddAlt1Icon sx={{ verticalAlign: 'middle', mr: 1, color: "#1976d2" }} />
                    SNSで住人募集を成功させるには
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    住人募集もSNSならではのスピードと幅広い層へのリーチが強みです。ただし、募集方法や掲載内容次第で、集まる人の質やマッチ度が大きく変わります。成功のポイントを解説します。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <GroupIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="「生活イメージ」が伝わる写真や動画を掲載"
                            secondary="内装だけでなく、共有スペース、住人の雰囲気、近隣環境も見せると安心感がアップ。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="必須情報は「まとめ画像」や「固定ツイート」に"
                            secondary="家賃、初期費用、立地、入居日、条件（男女可・ペット可など）は、画像やプロフィールの固定欄にまとめて掲載。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <EmojiPeopleIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="募集文は「どんな人に住んでほしいか」も明記"
                            secondary="年齢層、性格、趣味、生活リズムなど、自分たちが大切にしている価値観や理想像を具体的に。"
                        />
                    </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#fafafa', mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                SNS募集文のチェックリスト
                            </Typography>
                            <List sx={{ pl: 2 }}>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="家賃・共益費・初期費用" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="最寄り駅・交通アクセス" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="部屋・設備・写真" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="募集条件（性別・年齢・ペット等）" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="住人のプロフィールや生活イメージ" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1 }}>
                            <img
                                src="/images/blog/sharehouse-living_roomshare-sns-tips.jpg"
                                alt="明るい共有リビングで複数のルームメイトがくつろぎながら談笑している様子。木目調の家具と観葉植物が温かみのある雰囲気を演出し、SNS掲載写真のイメージとして最適"
                                style={{ width: '100%', borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" color="text.secondary">
                    アドバイス：<b>応募後のやりとりも丁寧に</b>。SNSのDMやメッセージで、まずはオンラインで軽く面談し、相性を見極めてから現地見学につなげるのがコツです。
                </Typography>
            </Box>

            {/* SNS活用でトラブルを防ぐポイント */}
            <Box id="trouble_avoidance" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <ShieldOutlinedIcon sx={{ verticalAlign: 'middle', mr: 1, color: "#1976d2" }} />
                    SNS活用でトラブルを防ぐポイント
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    SNSは便利な反面、トラブルのリスクもゼロではありません。安心安全なルームシェアライフを守るために、必ず押さえておきたい注意点をまとめました。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <WarningAmberIcon color="warning" />
                        </ListItemIcon>
                        <ListItemText
                            primary="「現地見学なしの即決」は避ける"
                            secondary="写真や動画だけでは分からない点も多いため、必ず現地を訪れて設備や住人の雰囲気を確認しましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <WarningAmberIcon color="warning" />
                        </ListItemIcon>
                        <ListItemText
                            primary="金銭や契約はSNS外で公式に"
                            secondary="家賃の前払い・デポジット送金などは、原則として契約内容を書面で交わしてから。領収証ややりとりの記録も残しておくこと。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <WarningAmberIcon color="warning" />
                        </ListItemIcon>
                        <ListItemText
                            primary="相手の素性や過去のやりとりを確認"
                            secondary="SNSのプロフィールやフォロワー、過去の投稿を見て、信頼できる人物・団体かチェックしましょう。"
                        />
                    </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#fffbea' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                トラブルを防ぐためのチェックポイント
                            </Typography>
                            <List sx={{ pl: 2 }}>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="見学時は必ず第三者を同行、または家族・友人に伝えておく" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="賃貸契約書の有無・内容を必ず確認" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="家賃や共益費の入金方法・期日を明確に" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="生活ルールや禁止事項は事前に話し合い、文書で残す" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" color="text.secondary">
                    トラブル防止には「<b>記録を残すこと</b>」が何より有効。やりとりはできるだけSNS内のメッセージ機能かメールを利用し、スクリーンショットも保存しましょう。
                </Typography>
            </Box>

            {/* SNS活用ルームシェア体験談 */}
            <Box id="experience" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <ForumIcon sx={{ verticalAlign: 'middle', mr: 1, color: "#1976d2" }} />
                    SNS活用ルームシェア体験談
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    実際にSNSを活用してルームシェアを始めた方々のリアルな声を紹介します。成功した事例や、ちょっとした失敗談から学べるポイントも多数あります。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    Instagramで理想のルームメイトと出会えた！
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <b>「#ルームシェア募集」で検索して、投稿に載っていた明るいリビングと料理好きな住人の雰囲気に惹かれて応募。内覧もスムーズで、今では一緒にシェア飯を楽しむ仲間になりました。」</b>
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <Chip label="20代女性・会社員" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    LINEオープンチャットで安心できる物件に
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <b>「LINEのオープンチャットで実際の住人に質問できたので、不安が解消。現地見学も丁寧に対応してもらい、安心して入居できました。」</b>
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <Chip label="30代男性・フリーランス" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    SNSだけで決めて失敗も…
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <b>「写真は素敵だったけど、実際に行ってみたら写真と違うし、住人とも合わず…。SNSでのやりとりだけで決めず、必ず現地やオンライン面談で確認を！」</b>
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <Chip label="20代男性・学生" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1 }}>
                            <img
                                src="/images/blog/roommate-online-meeting_roomshare-sns-tips.jpg"
                                alt="自宅のデスク前でノートパソコンを使い、オンライン面談を通じてルームメイト候補と会話する女性。明るい照明とカジュアルな服装が、SNS活用の現代的なルームシェア探しを象徴"
                                style={{ width: '100%', borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" color="text.secondary">
                    体験談から分かる通り、<b>SNSは出会いの幅を広げる強力なツール</b>。でも、リアルな確認や相性チェックも忘れずに！
                </Typography>
            </Box>

            {/* まとめとワンポイントアドバイス */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめとワンポイントアドバイス
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    SNSを活用したルームシェアは、<b>スピード・多様性・柔軟性</b>が最大の魅力です。一方で、トラブル回避や信頼性の見極め、リアルなコミュニケーションの大切さも忘れてはいけません。
                </Typography>
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2, bgcolor: '#e3f2fd', mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        専門家のワンポイントアドバイス
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="SNSの情報＋リアルな確認で納得のルームシェアを"
                                secondary="SNSは便利な反面、現地見学や面談を必ず行い、後悔のない選択をしましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="募集も応募も「誠実なやりとり」が信頼を生む"
                                secondary="挨拶・返信・条件説明など、SNSでも丁寧さを忘れずに。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="不安や疑問は「勇気を出して質問」"
                                secondary="納得できるまで質問し、少しでも不審な点があれば遠慮なく断りましょう。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" color="text.secondary">
                    ルームシェアをSNSで探す・募集するなら、「情報の質」と「人との信頼関係」を大切に。上手にSNSを活用して、あなたらしい素敵なルームシェアライフを見つけましょう！
                </Typography>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-sns-tips',
    slug: 'roomshare-sns-tips',
    title: 'ルームシェアの「おすすめSNS活用法」',
    excerpt: 'SNSでの物件探し、住人募集のコツ、トラブル回避のポイント、体験談を徹底解説。SNS時代のルームシェア成功術をわかりやすく紹介します。',
    coverImage: '/images/blog/cover-roomshare-sns_roomshare-sns-tips.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。木目調の家具や観葉植物がリラックスした雰囲気を演出し、SNS時代の多様な暮らし方を象徴している',
    publishedAt: '2024-06-15T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '住まい探し', 'SNS活用'],
    tags: ['ルームシェア', 'SNS', '物件探し', '住人募集', 'トラブル対策'],
    author: {
        name: '坂本 健太',
        avatar: '/images/avatars/sakamoto-kenta.jpg',
        bio: 'シェアハウス運営歴10年以上。全国のルームシェア事情・SNS活用に精通し、現場の経験と最新トレンドを分かりやすく発信中。',
        profilePicture: '/images/avatars/sakamoto-kenta.jpg'
    },
    viewCount: 1000,
    contentComponent: PostContent
};

export default post;